import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_INFO_PROMPT_ASSET_PAGE } from "../../../store/actionTypes/assetActionType";

const AssetsManagerInfoPrompt = () => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation();

  const { isInfoPromptAssetPage: isInfo, infoMessageAssetPage: infoMessage } =
    useSelector((state) => state.asset);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_INFO_PROMPT_ASSET_PAGE, payload: false });
  };

  return (
    isInfo && (
      <Alert
        sx={{ my: 2 }}
        severity="info"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("infoPromptTitle")}</AlertTitle>
        {infoMessage}
      </Alert>
    )
  );
};

export default AssetsManagerInfoPrompt;
